import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { init2 } from "./Tes";
import HomePart2 from "./HomePart2";
import $ from "jquery";
import APIs,{ _GetRequest } from "../../api";

function HomePart1() {
  const [homeSet1, setHomeSet1Data] = useState();
  const [loader, setLoader] = useState(false);

  const sliderSettings = {
    slidesToShow: 1,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    dots: true,
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    (async()=>{
      try {
          setLoader(true)
        let respHomeData1 = await _GetRequest(APIs.home_api_set1);
        if(respHomeData1.data){
          setLoader(false);
          setHomeSet1Data(respHomeData1.data)
        }
        } catch (error) {
          console.log(error?.message);
          setLoader(false);
        }
    })()
  }, []);

  useEffect(() => {
    if (homeSet1?.spotlight) {
      const el = document.getElementById("mid-section-body");
      if (el) {
        el.innerHTML = homeSet1?.spotlight?.html;
      }
    }
    if (homeSet1?.impact) {
      const el1_impact = document.getElementById("impact-section-body");
      if (el1_impact) { 
        el1_impact.innerHTML = homeSet1?.impact?.html;
        const box = document.getElementsByClassName("counters");
        if (box) {
          const counters = document.querySelectorAll(".counters span");
          const container = document.querySelector(".counters");
          let activated = false;
          window.addEventListener("scroll", () => {
			  
    		  var position = el1_impact.getBoundingClientRect();
            if ( position.top < window.innerHeight && position.bottom >= 0 && activated === false
            ) { 
              counters.forEach((counter) => {
                counter.innerText = 0;
                let count = 0;
                function updateCount() { 
                  const target = parseFloat(parseFloat(counter.dataset.count).toFixed(2)); //parseInt(counter.dataset.count);
                  if (count < target) {
                    count++;
                    counter.innerText = count;
                    setTimeout(updateCount, 10);
                  } else {
                    counter.innerText = target;
                  }
                }
                updateCount();
                activated = true;
              });
            } else if (
              window.pageYOffset <
                container.offsetTop - container.offsetHeight - 500 ||
              (window.pageYOffset === 0 && activated === true)
            ) {
              counters.forEach((counter) => {
                counter.innerText = 0;
              });
              activated = false;
            }
          });
        }
      }
    }
  
    if ($(".slider-services").length) {
      init2();
    } 
  }, [homeSet1]);
  
  let upcoming_latest = window["_dsci_staticdata_homepage"]("upcoming_latest");
  const display_upcoming = upcoming_latest["upcoming_visible"];
  const upcoming_active = upcoming_latest["default"] === "upcoming" ? "active" : "";
  const whatsnew_active = upcoming_latest["default"] === "whats_new" ? "active" : "";
  const upcoming_active_body = upcoming_latest["default"] === "upcoming" ? "active show" : "";
  const whatsnew_active_body = upcoming_latest["default"] === "whats_new" ? "active show" : "";
  
  return (
    <React.Fragment>
      <div className="page-front">
        <div className="banner">
          <div className="slick-slider">
            <Slider {...sliderSettings}>
              {homeSet1?.carousel?.map((banner, index) => {
                return (
                  <div className="element element-1" key={index}>
                    <div className="banner-middle-img">
                      <a href={banner?.url} target="_blank" rel="noopener noreferrer" >
                        <img loading="lazy" src={banner?.banner} alt={banner?.title} className="img-fluid" />
                      </a>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
        {/* Mid section block */}
        <div className="home-mid-section-div" id="mid-section-body"></div>
        {/* upcoming & latest block */}
        <div className="box-2 ">
          <div className="container-fluid">
            <div className="container-main">
              <div className="nav2 ">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  {display_upcoming ? (
                    <React.Fragment>
                      <li className="nav-item" role="presentation">
                        <button
                          className={upcoming_active + " nav-link "}
                          id="home-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#home"
                          type="button"
                          role="tab"
                          aria-controls="home"
                          aria-selected="true"
                        >
                          Upcoming
                        </button>
                      </li>
                    </React.Fragment>
                  ) : ( "" )}
                  <li className="nav-item" role="presentation">
                    <button
                      className={whatsnew_active + " nav-link "}
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile"
                      type="button"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                    >
                      What’s New
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                {display_upcoming ? (
                  <React.Fragment>
                    <div className={upcoming_active_body + " tab-pane fade "} id="home" role="tabpanel" aria-labelledby="home-tab" >
                      <div className="row row-eq-heigh">
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab" >
                          <div className="upcoming ">
                            <div className="row row-eq-heigh">
                              {homeSet1?.upcoming?.map((upcome, index) => {
                                  const strtitle = upcome.title;
                                  const strbody = upcome?.body;
                                  const maxlength = 220;
                                  const title_length = strtitle.length >= 25 ? strtitle.length : 25;
                                  const body = strbody.substring( 0, maxlength - title_length ) + "...";
                                  const el1 = document.getElementById( "p-" + index );

                                  return (
                                    <div className="col-lg-6  d-flex align-items-stretch" id={`nid-${upcome.nid}`} key={`nid-${upcome.nid}`}>
                                      <div className="box-3 float transition-a1 ">
                                        <div className="row h-100">
                                          <div className="col-lg-5 col-sm-5">
                                            <img loading="lazy" src={upcome?.thumbnail} alt={upcome.title} className="img-fluid" />
                                          </div>
                                          <div className="col-lg-7 col-sm-7">
                                            <div className="w-100 box-3-box ">
                                              <div className="ribbon-pop float-end"
                                                style={{ backgroundColor: upcome?.label_color ?.background_color, color: upcome?.label_color?.color, }}
                                              >
                                                <span> { upcome?.label } </span>
                                              </div>
                                              <h3> { upcome?.announcement }{" "} </h3>
                                              <h4>
                                                <a href={ upcome.url } target="_blank" style={{ textDecoration: "none", }} rel="noopener noreferrer" >
                                                  {upcome.title}
                                                </a>
                                              </h4>
                                              <p>{body}</p>
                                              <a href={ upcome.url } target="_blank" rel="noopener noreferrer" >
                                                <div className="s-arrow float-end mb-4">
                                                  <img loading="lazy" src={ process.env.PUBLIC_URL + "/assets/img/Vector8.webp" } alt="Vector8" />
                                                </div>
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ) : ( "" )}
                <div className={whatsnew_active_body + " tab-pane fade "} id="profile" role="tabpanel" aria-labelledby="profile-tab" >
                  <div className="whatsnew">
                    <div className="row row-eq-heigh">
                      <div className="col-lg-12">
                        <div className="float-end">
                          <Link to="/latest-at-dsci" className="view-all skew">
                            View all <i className="fas fa-angle-right ms-2"></i>
                          </Link>
                        </div>
                      </div>
                      {homeSet1?.latest
                        ?.map((latest, index) => {
                          const strtitle = latest.title;
                          const strbody = latest?.body;
                          const maxlength = 220;
                          const title_length = strtitle.length >= 25 ? strtitle.length : 25;
                          const body = strbody.substring(0, maxlength - title_length) + "...";
                          const el2 = document.getElementById("lp-" + index);

                          return (
                            <div className="col-lg-6  d-flex align-items-stretch" id={`nid-${latest.nid}`} key={`nid-${latest.nid}`}>
                              <div className="box-3 float transition-a1">
                                <div className="row ">
                                  <div className="col-lg-5 col-sm-5">
                                    <img src={latest?.thumbnail} alt={latest.title} className="img-fluid" />
                                  </div>
                                  <div className="col-lg-7 col-sm-7">
                                    <div className="w-100 box-3-box">
                                      <h3>
                                        <i></i>
                                        <img src={ process.env.PUBLIC_URL + "/assets/img/date 1.svg" } className="me-2 calendar-icon" alt="date1" />
                                        <span> {" "} {latest?.published_date} </span>{" "}
                                      </h3>
                                      <h4> {" "} <a href={latest?.url} target="_blank" style={{ textDecoration: "none" }} rel="noopener noreferrer" > {latest.title} </a> </h4>
                                      <p>{body}</p>
                                      <a href={latest?.url} target="_blank" rel="noopener noreferrer" >
                                        {" "}
                                        <div className="s-arrow float-end mb-3">
                                          <img src={ process.env.PUBLIC_URL + "/assets/img/Vector8.webp" } alt="Vector8" />
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      <div className="col-lg-12 for-mobile-box3">
                        <div className="float-end">
                          <Link to="/latest-at-dsci" className="view-all skew">
                            View all <i className="fas fa-angle-right ms-2"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="home-impact-section-div" id="impact-section-body"></div>
        <HomePart2 />
      </div>
    </React.Fragment>
  );
}

export default HomePart1;
